import { z } from 'zod';
import { AiProvider } from './ai.js';
/**
 * Năng lực theo **model**, không theo provider — APM-H-l (`plan-harness.md` §8.2).
 *
 * Cùng LiteLLM nhưng model sau nó có thể là Claude, GPT reasoning, hay model
 * không suy nghĩ; hồ sơ theo provider không phân biệt được. Hàng ở đây là kết
 * quả **kiểm thật** (`verifiedByPing`) hoặc admin khai tay; thiếu hàng thì
 * gateway dùng hồ sơ provider như trước.
 */
export const ThinkingStyle = z.enum(['anthropic_adaptive', 'openai_reasoning_effort', 'none']);
export const AiModelCapability = z.object({
    modelId: z.string(),
    provider: AiProvider,
    supportsThinking: z.boolean(),
    thinkingStyle: ThinkingStyle,
    supportsOutputFormat: z.boolean(),
    supportsCacheControl: z.boolean(),
    /** Đọc được ảnh trong kết quả tool — APM-DC-h0. Admin khai; ping không kiểm được. */
    supportsVision: z.boolean(),
    /** Lần kiểm bằng ba `ping` gần nhất; `null` = admin khai tay, chưa kiểm. */
    verifiedAt: z.iso.datetime().nullable(),
    verifiedByPing: z.boolean(),
    notes: z.string().nullable(),
    updatedAt: z.iso.datetime(),
});
export const UpsertModelCapabilityInput = z.object({
    modelId: z.string().trim().min(1).max(60),
    provider: AiProvider,
    supportsThinking: z.boolean(),
    thinkingStyle: ThinkingStyle,
    supportsOutputFormat: z.boolean(),
    supportsCacheControl: z.boolean(),
    /** Mặc định `false`: không khai là không đoán model đọc được ảnh (APM-DC-h0). */
    supportsVision: z.boolean().default(false),
    notes: z.string().trim().max(500).nullable().optional(),
});
/** Kết quả một lần `verify`: ba `ping` nhỏ, mỗi cái một câu trả lời có/không kèm lỗi. */
export const ModelVerifyCheck = z.object({
    ok: z.boolean(),
    latencyMs: z.number().int().nonnegative(),
    costUsd: z.string(),
    error: z.string().nullable(),
});
export const ModelVerifyResult = z.object({
    modelId: z.string(),
    checks: z.object({ thinking: ModelVerifyCheck, outputFormat: ModelVerifyCheck, cacheControl: ModelVerifyCheck }),
    capability: AiModelCapability,
});
/** Một hàng của tab Model (H-k): giá đang hiệu lực + năng lực, gộp theo `modelId`. */
export const AiModelRow = z.object({
    modelId: z.string(),
    /** Giá đang hiệu lực (`effectiveTo = null`), `null` khi chưa có bảng giá. */
    inputPerMTokUsd: z.string().nullable(),
    outputPerMTokUsd: z.string().nullable(),
    capability: AiModelCapability.nullable(),
});
//# sourceMappingURL=ai-model-capability.js.map